export default __webpack_public_path__ + "static/media/Band-Protocol-Graphic.37883ebc.png";